import { useMutation } from "@apollo/client";
import { enqueueSnackbar } from "notistack";
import { useCallback } from "react";
import { DELETE_PUBLIC_TOKEN } from "./commands";

export function useDeletePublicToken(
  onCompleted = () => {},
  onError = () => {},
) {
  const [deletePublicToken, { loading }] = useMutation(DELETE_PUBLIC_TOKEN, {
    onCompleted,
    onError: (err) => {
      onError(err);

      enqueueSnackbar(err.message, {
        variant: "error",
      });
    },
    refetchQueries: ["GetPublicToken"],
    errorPolicy: "all",
  });

  const deleteToken = useCallback(() => {
    deletePublicToken().then();
  }, [deletePublicToken]);

  return {
    delete: deleteToken,
    deleting: loading,
  };
}
